/**
 * @generated SignedSource<<7aaa2d3d5a3723ebfbae2f3eea5845c4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CodepushVersionActionEnum = "codepush_version_update_production" | "codepush_version_update_staging" | "%future added value";
export type CodepushVersionId_codepushVersionQuery$variables = {
  id: string;
};
export type CodepushVersionId_codepushVersionQuery$data = {
  readonly codepushVersion: {
    readonly actions: ReadonlyArray<CodepushVersionActionEnum>;
    readonly id: string;
    readonly targetBinaryVersion: string;
    readonly version: number;
    readonly " $fragmentSpreads": FragmentRefs<"CodepushVersionDescriptionList_codepushVersion" | "CodepushVersionStatusLabel_codepushVersion" | "CodepushVersionUpdateDialog_codepushVersion">;
  };
};
export type CodepushVersionId_codepushVersionQuery = {
  response: CodepushVersionId_codepushVersionQuery$data;
  variables: CodepushVersionId_codepushVersionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "version",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "targetBinaryVersion",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actions",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CodepushVersionId_codepushVersionQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CodepushVersion",
        "kind": "LinkedField",
        "name": "codepushVersion",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CodepushVersionStatusLabel_codepushVersion"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CodepushVersionDescriptionList_codepushVersion"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CodepushVersionUpdateDialog_codepushVersion"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CodepushVersionId_codepushVersionQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CodepushVersion",
        "kind": "LinkedField",
        "name": "codepushVersion",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "severity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "created",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3904b6c61b241eea133e5c91b8fb4933",
    "id": null,
    "metadata": {},
    "name": "CodepushVersionId_codepushVersionQuery",
    "operationKind": "query",
    "text": "query CodepushVersionId_codepushVersionQuery(\n  $id: ID!\n) {\n  codepushVersion(id: $id) {\n    id\n    version\n    targetBinaryVersion\n    actions\n    ...CodepushVersionStatusLabel_codepushVersion\n    ...CodepushVersionDescriptionList_codepushVersion\n    ...CodepushVersionUpdateDialog_codepushVersion\n  }\n}\n\nfragment CodepushVersionDescriptionList_codepushVersion on CodepushVersion {\n  id\n  version\n  targetBinaryVersion\n  severity\n  title\n  created\n  ...CodepushVersionStatusLabel_codepushVersion\n}\n\nfragment CodepushVersionStatusLabel_codepushVersion on CodepushVersion {\n  status\n}\n\nfragment CodepushVersionUpdateDialog_codepushVersion on CodepushVersion {\n  id\n  title\n  severity\n}\n"
  }
};
})();

(node as any).hash = "76155c9b9a2ade6704b27450a3345ab0";

export default node;
